module.exports = __webpack_public_path__ + "static/media/rv.ed35711d.svg";